export default __webpack_public_path__ + "static/media/avatar-.ceba8d56.png";